<script lang="ts">
  import { router } from "@inertiajs/svelte";
  import { addNotification } from "../../lib/stores";
  import Modal from "../overlay/Modal.svelte";

  let {
    tripId,
    customRates = {},
    show = $bindable(false),
    onClose,
  }: {
    tripId: string;
    customRates?: Record<string, number>;
    show?: boolean;
    onClose?: () => void;
  } = $props();

  const commonCurrencies = [
    { code: "USD", name: "미국 달러", symbol: "$" },
    { code: "EUR", name: "유로", symbol: "€" },
    { code: "JPY", name: "일본 엔", symbol: "¥" },
    { code: "CNY", name: "중국 위안", symbol: "¥" },
    { code: "GBP", name: "영국 파운드", symbol: "£" },
    { code: "AUD", name: "호주 달러", symbol: "A$" },
    { code: "CAD", name: "캐나다 달러", symbol: "C$" },
    { code: "CHF", name: "스위스 프랑", symbol: "Fr" },
    { code: "HKD", name: "홍콩 달러", symbol: "HK$" },
    { code: "SGD", name: "싱가포르 달러", symbol: "S$" },
    { code: "THB", name: "태국 바트", symbol: "฿" },
    { code: "VND", name: "베트남 동", symbol: "₫" },
  ];

  let rates: Record<string, string> = $state({});
  let loading = $state(false);

  $effect(() => {
    const next: Record<string, string> = {};
    commonCurrencies.forEach(currency => {
      if (customRates && customRates[currency.code]) {
        next[currency.code] = String(customRates[currency.code]);
      }
    });
    rates = next;
  });

  async function saveRates() {
    loading = true;

    try {
      const exchange_rates: Record<string, number> = {};
      Object.entries(rates).forEach(([code, value]) => {
        const numValue = parseFloat(value);
        if (value && !isNaN(numValue) && numValue > 0) {
          exchange_rates[code] = numValue;
        }
      });

      const response = await fetch(`/api/v1/trips/${tripId}/update_exchange_rates`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ exchange_rates }),
      });

      if (!response.ok) {
        throw new Error("환율 설정에 실패했습니다");
      }

      addNotification("success", "기준 환율이 설정되었습니다");
      router.reload();
      close();
    } catch (error: any) {
      addNotification("error", error.message || "환율 설정에 실패했습니다");
    } finally {
      loading = false;
    }
  }

  function close() {
    show = false;
    rates = {};
    onClose?.();
  }
</script>

<Modal {show} title="기준 환율 설정" onClose={close}>
  <div class="space-y-4">
    <p class="text-sm text-gray-600">
      여행 중 사용하는 통화의 기준 환율을 설정하세요.
      <br />설정된 환율로 모든 지출이 재계산됩니다.
    </p>

    <div class="space-y-3 max-h-[400px] overflow-y-auto">
      {#each commonCurrencies as currency}
        <div class="flex items-center gap-3">
          <div class="w-16 text-center">
            <span class="text-2xl">{currency.symbol}</span>
          </div>
          <div class="flex-1">
            <label for="rate-{currency.code}" class="block text-sm font-medium text-gray-700 mb-1">
              {currency.name} ({currency.code})
            </label>
            <div class="relative">
              <input
                id="rate-{currency.code}"
                type="number"
                bind:value={rates[currency.code]}
                placeholder="환율 입력 (예: 1300)"
                step="0.01"
                min="0"
                class="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <span class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">
                ₩
              </span>
            </div>
          </div>
        </div>
      {/each}
    </div>

    <div class="flex gap-3 pt-4 border-t">
      <button
        onclick={close}
        class="flex-1 py-3 bg-gray-100 text-gray-700 rounded-xl font-medium hover:bg-gray-200 transition-colors"
      >
        취소
      </button>
      <button
        onclick={saveRates}
        disabled={loading}
        class="flex-1 py-3 bg-blue-600 text-white rounded-xl font-medium hover:bg-blue-700 transition-colors disabled:opacity-50"
      >
        {loading ? "저장 중..." : "저장"}
      </button>
    </div>
  </div>
</Modal>
